<h2 mat-dialog-title>Filter by Suspect</h2>
<mat-dialog-content>
    <mat-selection-list [multiple]="false">
        <mat-list-option *ngFor="let info of filterSuspects" [value]="info" (click)="close(info)">
            {{info.name}}
        </mat-list-option>
    </mat-selection-list>
</mat-dialog-content>